<template>
  <div class="body-wrapper">

    <navigation-header/>

    <div class="layout-landing">

      <div ref="banner" class="banner">
        <div class="content">
          <div class="container">
            <div class="slogan">
              <div class="line-1">
                专家一对一<br class="visible-xs"/>个性化咨询服务
              </div>
              <div class="line-2">金牌团队&nbsp;&nbsp;&nbsp;完善数据<br class="hidden-not-xs"/><span class="hidden-xs">&nbsp;&nbsp;&nbsp;</span>丰富经验&nbsp;&nbsp;&nbsp;完美助力高考</div>
            </div>
          </div>
        </div>
      </div>

      <div class="teachers">
        <div class="container">
          <div class="title">
            <div class="line-1">
              优质团队师资
            </div>
            <div class="line-2">
              我们对老师对选拔标准：<br class="visible-xs"/>专业、专注、专家
            </div>
          </div>
          <div class="row">
            <a v-for="teacher of teachers" :href="'/about/teacher#' + teacher._id" class="teacher-wrapper col-sm-3">
              <div class="teacher">
                <div class="photo" :style="{'background-image': getStyleUrl(teacher.photoUrl)}"></div>
                <div class="info" :class="{highlighted: teacher.isSuperior}">
                  <div class="name">{{teacher.name}}</div>
                  <div class="job-title">
                    <i v-if="teacher.isSuperior" class="icon icon-18 icon-medal"></i><span class="text">{{teacher.jobTitle}}</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div class="button-wrapper">
            <a class="link" href="/about/teacher"><span class="text">查看更多师资信息</span><i class="icon icon-14 icon-arrow-right-black"></i></a>
          </div>
        </div>
      </div>

      <div class="products">
        <div class="container">
          <div class="title">
            <div class="line-1">
              服务内容
            </div>
            <div class="line-2">
              我们专注于高考咨询服务，<br class="visible-xs"/>帮助您轻松准确的找到打开大学之门的钥匙
            </div>
          </div>
          <div class="title"></div>
          <div class="list">
            <div class="item">
              <div class="jarallax image-with-name image-2" data-speed="0.7">
                <div class="name-wrapper">
                  <div class="name">志愿填报</div>
                </div>
              </div>
              <div class="info">
                <div class="desc">
                  高考志愿填报一对一个性化服务，是帮助考生及家长基于学生自身性格特点及职业规划来科学地选择大学专业及院校。<br/>
                  由阳光生涯资深规划师根据自身丰富的报考经验、考生的学习情况、兴趣爱好、职业倾向并结合家长的意愿，由资深高考志愿填报专家给考生作出专业客观的分析报告，帮助考生挑选理想的大学和专业，为考生量身打造一套科学、合理、有效的志愿填报方案。
                </div>
                <div class="button-wrapper">
                  <a href="/college-application" class="link"><span class="text">查看详情</span><i class="icon icon-14 icon-arrow-right-white"></i></a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="jarallax image-with-name image-1" data-speed="0.7">
                <div class="name-wrapper">
                  <div class="name">强基计划</div>
                </div>
              </div>
              <div class="info">
                <div class="desc">
                  强基计划是指有关高校要突出基础学科的支撑引领作用，重点在数学、物理、化学、生物及历史、哲学、古文字学等相关专业招生，为高端芯片与软件、智能科技、新材料、先进制造和国家安全等关键领域以及国家人才紧缺的人文社会科学领域培养人才。<br/>
                  2020年，正式实施强基计划，而不再组织开展高校自主招生工作。
                </div>
                <div class="button-wrapper">
                  <a href="/student-recruitment" class="link"><span class="text">查看详情</span><i class="icon icon-14 icon-arrow-right-white"></i></a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="jarallax image-with-name image-3" data-speed="0.7">
                <div class="name-wrapper">
                  <div class="name">生涯规划</div>
                </div>
              </div>
              <div class="info">
                <div class="desc">
                  新高考改革后的教育体制会给高中生提供更多选择机会，同时对学生也提出了更多的要求。<br/>
                  如果学生在高中阶段很难认清自己，作出正确抉择，对他的发展是十分不利的。"专业导向"的考录趋势，要求学生尽早了解自己的兴趣特点和专业取向，生涯规划显得尤为重要。
                </div>
                <div class="button-wrapper">
                  <a href="/career-planning" class="link"><span class="text">查看详情</span><i class="icon icon-14 icon-arrow-right-white"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="jarallax about-us" data-speed="0">
        <div class="content-wrapper">
          <div class="container">
            <div class="title">关于我们</div>
            <div class="desc">
              阳光生涯教育是专注于高中生志愿填报、强基计划、综合评价录取及高中生涯规划的专业机构。
              <br/><br/>
              公司拥有优质的教育资源，一流的专家团队，先进的软件信息技术及每年的高考院校录取、行业就业的大数据。
              公司每年在广东各个重点中学及各地举行了上百场校内外公益讲座，并与广州、深圳、佛山、东莞、中山、珠海、惠州、肇庆等地多所知名高中长期合作，并与国内上百所知名高校、港澳台知名院校进行深度交流合作，为广大珠三角高中家长服务，在业内深受好评。
              <br/><br/>
              选择阳光，踏上征服梦想的旅途。
            </div>
          </div>
        </div>
      </div>

      <div class="partners">

        <div class="container">

          <!--

          <div class="layout-section-title">
            <div class="section-title">合作伙伴</div>
          </div>
          <div class="list row">
            <div class="col-sm-6">
              <div class="item">
                <img class="image" src="../../images/partner_1.jpg" />
                <div class="info">
                  <div class="name">南方科技大学招生办</div>
                  <div class="desc">南方科技大学（Southern University of Science and Technology），简称“南科大”，是国家高等教育综合改革试验校，由广东省领导和管理的全日制公办普通高等学校。</div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="item">
                <img class="image" src="../../images/partner_2.jpg" />
                <div class="info">
                  <div class="name">香港中文大学招生办</div>
                  <div class="desc">香港中文大学（The Chinese University of Hong Kong），简称港中大（CUHK），书院制大学建制，为世界大学联盟、环太平洋大学联盟、亚太国际教育协会、中国大学校长联谊会、京港大学联盟重要成员。</div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="item">
                <img class="image" src="../../images/partner_3.jpg" />
                <div class="info">
                  <div class="name">中山大学招生办</div>
                  <div class="desc">中山大学（Sun Yat-sen University, SYSU），简称“中大”，由孙中山先生创办，有着一百多年办学传统，是中国南方科学研究、文化学术与人才培养的重镇。</div>
                </div>
              </div>
            </div>
          </div>

          <div class="separator"></div>

          -->

          <div class="layout-section-title">
            <div class="section-title">友情链接</div>
          </div>
          <div class="links">
            <a class="link" href="#"><img src="../../images/link_1.jpg" /></a>
            <a class="link" href="#"><img src="../../images/link_2.jpg" /></a>
          </div>

        </div>

      </div>

    </div>

    <navigation-footer/>

  </div>
</template>

<script type="text/babel">
  'use strict';

  import $ from 'jquery';
  import objectFitImages from 'object-fit-images';
  import {
    jarallax,
    jarallaxElement,
  } from 'jarallax';

  export default {
    computed: {
      teachers() {
        return window.preload.data.teachers;
      },
      isMobile() {
        return this.$utils.isMobile();
      }
    },
    mounted () {
      this.updateBannerImage();
      $(window).scroll(() => {
        this.updateBannerImage();
      });
      objectFitImages();
      jarallaxElement();
      jarallax(document.querySelectorAll('.jarallax'));
    },
    methods: {
      getStyleUrl(url) {
        return `url('${url}')`;
      },
      updateBannerImage() {
        let scrolledY = $(window).scrollTop();
        let height = 360;
        let opacity = 1 - (Math.min(scrolledY, height) / height);
        if (this.isMobile) {
          scrolledY -= 30;
        }
        $(this.$refs.banner).css({'background-position': 'center ' + scrolledY + 'px', opacity});
      }
    }
  };
</script>


// WEBPACK FOOTER //
// client/app/vue-components/landing/App.vue